const module = { name: 'swig/lib/utils', exports: {} }; const exports = module.exports;



let _isArray
exports.strip = function (input) {
    return input.replace(/^\s+|\s+$/g, '');
};
exports.startsWith = function (str, prefix) {
    return str.indexOf(prefix) === 0;
};
exports.endsWith = function (str, suffix) {
    return str.indexOf(suffix, str.length - suffix.length) !== -1;
};
exports.each = function (obj, fn) {
    let i, l;
    if (_isArray(obj)) {
        i = 0;
        l = obj.length;
        for (i; i < l; i += 1) {
            if (fn(obj[i], i, obj) === false) {
                break;
            }
        }
    }
    else {
        for (i in obj) {
            if (obj.hasOwnProperty(i)) {
                if (fn(obj[i], i, obj) === false) {
                    break;
                }
            }
        }
    }
    return obj;
};
_isArray = (Array.hasOwnProperty('isArray')) ? Array.isArray : function (obj) {
    return (obj) ? (typeof obj === 'object' && Object.prototype.toString.call(obj).indexOf() !== -1) : false;
};
exports.isArray = _isArray;
exports.some = function (obj, fn) {
    let i = 0;
    let result;
    let l;
    if (_isArray(obj)) {
        l = obj.length;
        for (i; i < l; i += 1) {
            result = fn(obj[i], i, obj);
            if (result) {
                break;
            }
        }
    }
    else {
        exports.each(obj, (value, index) => {
            result = fn(value, index, obj);
            return !(result);
        });
    }
    return !!result;
};
exports.map = function (obj, fn) {
    let i = 0;
    const result = [];
    let l;
    if (_isArray(obj)) {
        l = obj.length;
        for (i; i < l; i += 1) {
            result[i] = fn(obj[i], i);
        }
    }
    else {
        for (i in obj) {
            if (obj.hasOwnProperty(i)) {
                result[i] = fn(obj[i], i);
            }
        }
    }
    return result;
};
exports.extend = function () {
    const args = arguments;
    const target = args[0];
    const objs = (args.length > 1) ? Array.prototype.slice.call(args, 1) : [];
    let i = 0;
    const l = objs.length;
    let key;
    let obj;
    for (i; i < l; i += 1) {
        obj = objs[i] || {};
        for (key in obj) {
            if (obj.hasOwnProperty(key)) {
                target[key] = obj[key];
            }
        }
    }
    return target;
};
exports.keys = function (obj) {
    if (!obj) {
        return [];
    }
    if (Object.keys) {
        return Object.keys(obj);
    }
    return exports.map(obj, (v, k) => k);
};
exports.throwError = function (message, line, file) {
    if (line) {
        message += ' on line ' + line;
    }
    if (file) {
        message += ' in file ' + file;
    }
    throw new Error(message + '.');
};
export default module.exports;